import { render, staticRenderFns } from "./PraesidentInnen.vue?vue&type=template&id=29728180&scoped=true&"
import script from "./PraesidentInnen.vue?vue&type=script&lang=js&"
export * from "./PraesidentInnen.vue?vue&type=script&lang=js&"
import style0 from "./PraesidentInnen.vue?vue&type=style&index=0&id=29728180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29728180",
  null
  
)

export default component.exports